import { render, staticRenderFns } from "./WeeklyTasks.vue?vue&type=template&id=4c3008a6&lang=pug"
import script from "./WeeklyTasks.vue?vue&type=script&lang=js"
export * from "./WeeklyTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports